module.exports = __webpack_public_path__ + "img/san-jose-room-5.00069b60.jpg";